import API_PATH from './actionsFactory/apiPath';
import { setPostBody } from './actionsFactory';
import { eraseCookie, readCookie } from '../utils/cookies-browser';


export default {
  ensureLogged: (_, callback) => {
    callback({ notLogged: true });
  },
  isLogged: async (_, callback) => {
    const { gwPost } = require('./actionsFactory/gwRequest');
    try {
      const cr00 = readCookie('cr00');
      if (!cr00) throw new Error();
      const data = await gwPost(
        API_PATH.USER_VERIFY_TOKEN,
        { ...setPostBody() },
        null, true,
        {
          withClientApiCache: true,
          isExpiredFromResponse: true,
        },
      );
      if (!data.success) throw new Error();
      callback({ logged: true });
    } catch (err) {
      eraseCookie('logined');
      callback({ logged: false });
    }
  },
};
